import {webClient} from "../../config/axios";
import {handleError} from "../handleRequestError";


export const profileRequest = (callback) => {
    webClient.get('/user/profile')
        .then(response => {
            callback(response.data, false);
        })
        .catch(err => {
            handleError(err, callback);
        })
};

export const updateProfileRequest = (body,callback) => {
    webClient.put('/user/profile', body, {
        headers: {
            "Content-Type": "application/json"
        },
        timeout: 0
    })
        .then(response => {
            callback(response.data, false);
        })
        .catch(err => {
            handleError(err, callback);
        })
};

export const updatePasswordRequest = (body,callback) => {
    webClient.post('/user/pass', body, {
        headers: {
            "Content-Type": "application/json"
        },
        timeout: 0
    })
        .then(response => {
            callback(response.data, false);
        })
        .catch(err => {
            handleError(err, callback);
        })
};